import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAdminDefs } from "../lib/roles";

// oturum doğrulanırken: index.html'deki ilk boyama kabuğuyla aynı görünüm (koyu kenar menü + dönen simge) — yenilemede beyaz ekran yok
export function AppSplash() {
  return (
    <div className="app-splash" data-testid="app-splash" aria-busy="true" aria-label="Yükleniyor">
      <div className="splash-side" />
      <div className="splash-spin" />
    </div>
  );
}

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, isAdmin } = useAuth();
  if (user === null) return <AppSplash />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin && !canAdminDefs(user)) return <Navigate to="/dashboard" replace />;   // matristen "Yönetim ve Tanımlar" verilen roller de girer
  return children;
}
